
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const init = () => {
  gsap.registerPlugin(ScrollTrigger);
  const mapMain = document.querySelector('.js-mapMain');
  const pins = gsap.utils.toArray('.js-mapAnimationPin');
  const names = gsap.utils.toArray('.js-mapAnimationName');
  const borders = gsap.utils.toArray('.js-mapAnimationBorder path');
  const borderToLeft = gsap.utils.toArray('.js-mapAnimationBorder[data-direction="toLeft"] path');
  const borderToRight = gsap.utils.toArray('.js-mapAnimationBorder[data-direction="toRight"] path');
  borderToLeft.forEach(path => {
    const len = path.getTotalLength();
    gsap.set(
      path, {
        strokeDasharray: len,
        strokeDashoffset: len,
        onComplete: () => {
          gsap.set(path.closest('.js-mapAnimationBorder'), {opacity: 1});
        }
      }
    );
  });
  borderToRight.forEach(path => {
    const len = path.getTotalLength();
    gsap.set(path,
      {
        strokeDasharray: len,
        strokeDashoffset: len,
        onComplete: () => {
          gsap.set(path.closest('.js-mapAnimationBorder'), {opacity: 1});
        }
      }
    );
  });
  const circles = gsap.utils.toArray('.js-mapAnimationCircle');

  const tl = gsap.timeline({
    // repeat: -1,
    // repeatDelay: 1,
    scrollTrigger: {
      trigger: mapMain,
      start: 'top center',
      end: 'bottom center',
    }
  });

  tl.to(pins, {
    autoAlpha: 1,
    y: 0,
    stagger: 0.5,
    duration: 0.5,
    ease: "power1.inOut"
  });
  tl.to(borders, {
    strokeDashoffset: 0,
    stagger: 0,
    duration: 0.5,
    ease: "power1.inOut"
  }, 1.5);
  tl.to(names, {
    autoAlpha: 1,
    stagger: 0,
    duration: 0.4,
    ease: "power1.inOut"
  }, 2.1);
  tl.to(circles, {
    autoAlpha: 1,
    stagger: 0.015,
    duration: 0.5,
    ease: "power1.inOut"
  }, 2.6);

}

export {
  init
}